<template>
  <v-container
    class="d-flex justify-center align-center flex-column"
    style="height: 80vh; max-width: 400px;"
  >
    <p>404</p>
    <p>Page not found</p>
    <p>
      The link you clicked may be broken or the page may have been removed or
      renamed.
    </p>
    <v-btn @click="$router.push('/')" color="primary" dark>
      GO TO HOME
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Page404",
};
</script>
